import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  toggleEditComment(event) {
    const id = event.target.getAttribute('data-id');
    $('#comment-' + id).toggle();
    $('#comment-edit-' + id).toggleClass('d-none');
  }
}
